import { Component, HostListener, Output, EventEmitter, Input } from '@angular/core';

@Component({

    selector: 'm4u-link',
    templateUrl: './link.component.html',
    styleUrls: ['./link.component.scss'],
})
export class M4ULinkComponent {
    @Input() href: string;
    @Input() Type: 'success' | 'danger' | 'normal' | 'default' = 'default';
    @Input() Disabled: boolean;
    @Input() Icon: string;
    @Input() Class: string;
    @Output() onClick = new EventEmitter();

    @HostListener("click", ["$event"])
    public OnClickHandler(event: any) {
        event.stopPropagation();
        if (this.Disabled) { return };
        this.onClick.emit();
    }

    GetClass() {
        return (this.Class || '') + (this.Type ? (' m4u-link-' + this.Type) : '');
    }
}
